<app-header></app-header>

<!-- Page Header Start -->
<div class="container-fluid page-header py-5">
    <div class="container text-center pd-t-120 pd-b-120">
        <h1 class="display-5 text-white mb-4">Our Blogs</h1>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb justify-content-center mb-0">
                <li class="breadcrumb-item"><a routerLink="/">Home</a></li>
                <li class="breadcrumb-item"><a routerLink="/">Pages</a></li>
                <li class="breadcrumb-item" aria-current="page">Blogs</li>
            </ol>
        </nav>
    </div>
</div>
<!-- Page Header End -->

<!-- Fact Start -->
<div class="container-fluid bg-color-secondary py-5">
  <div class="container">
    <div class="row">
      
      <!-- Loop over facts array using *ngFor -->
      <div *ngFor="let fact of facts" class="col-lg-3">
        <div class="d-flex counter">
          <h1 class="me-3 color-dark counter-value">{{ fact.value }}</h1>
          <h5 class="text-white mt-1">{{ fact.label }}</h5>
        </div>
      </div>

    </div>
  </div>
</div>
<!-- Fact End -->

<!-- Blog Start -->
<div class="container-fluid blog py-5 mb-5">
  <div class="container">
    <div class="text-center mx-auto pb-5 wow fadeIn" data-wow-delay=".3s" style="max-width: 600px;">
      <h5 class="color-primary">Our Blog</h5>
      <h1>Latest Blog & News</h1>
    </div>
    
    <div class="row g-5 justify-content-center">
      
      <!-- Loop over blogs array using *ngFor -->
      <div *ngFor="let blog of blogs" class="col-lg-6 col-xl-4">
        
        <div class="blog-item position-relative bg-light rounded">
          <img [src]="blog.blogImage" class="img-fluid w-100 rounded-top" [alt]="blog.category">
          <span class="position-absolute px-4 py-3 bg-color-primary text-white rounded" style="top: -28px; right: 20px;">
            {{ blog.category }}
          </span>
          
          <div class="blog-btn d-flex justify-content-between position-relative px-3" style="margin-top: -75px;">
            <div class="blog-icon btn btn-secondary px-3 rounded-pill my-auto">
              <a [routerLink]="blog.link" class="btn text-white">Read More</a>
            </div>
            
            <div class="blog-btn-icon btn btn-secondary px-4 py-3 rounded-pill">
              <div class="blog-icon-1">
                <p class="text-white px-2">Share<i class="fa fa-arrow-right ms-3"></i></p>
              </div>
              <div class="blog-icon-2">
                <a href="#." class="btn me-1"><i class="fab fa-facebook-f text-white"></i></a>
                <a href="#." class="btn me-1"><i class="fab fa-x-twitter text-white"></i></a>
                <a href="#." class="btn me-1"><i class="fab fa-instagram text-white"></i></a>
              </div>
            </div>
          </div>
          
          <div class="blog-content text-center position-relative px-3" style="margin-top: -25px;">
            <img [src]="blog.authorImage" class="img-fluid rounded-circle border border-4 border-white mb-3" [alt]="blog.authorName">
            <h6>By {{ blog.authorName }}</h6>
            <span class="color-secondary">{{ blog.date }}</span>
            <p class="py-2">{{ blog.summary }}</p>
          </div>
          
          <div class="blog-coment d-flex justify-content-between px-4 py-2 border bg-color-primary rounded-bottom">
            <a href="#." class="text-white"><small><i class="fas fa-share me-2 color-secondary"></i>{{ blog.shares }} Share</small></a>
            <a href="#." class="text-white"><small><i class="fa fa-comments me-2 color-secondary"></i>{{ blog.comments }} Comments</small></a>
          </div>
        </div>

      </div>

    </div>
  </div>
</div>
<!-- Blog End -->

